import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faMapMarkerAlt, 
  faClock 
} from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import { contattiAzienda } from '../utils/data';
import ContactForm from '../components/ContactForm';

const Contattaci: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-28 md:pt-32 pb-20 bg-gradient-to-br from-primary to-primary/80 text-white">
        <div className="container mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Contattaci</h1>
            <p className="text-xl text-white/80">
              Siamo qui per aiutarti. Contattaci per qualsiasi informazione o richiesta.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Contact Info */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:w-1/3"
            >
              <h2 className="text-3xl font-bold mb-8 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                Informazioni di Contatto
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start bg-gradient-to-r from-primary/5 to-secondary/5 p-4 rounded-xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-primary to-secondary rounded-xl mr-4 flex-shrink-0">
                    <FontAwesomeIcon icon={faPhone} className="text-lg text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2 text-gray-800">Telefono</h3>
                    <a href="tel:+390660513535" className="block text-primary hover:text-secondary font-semibold mb-1">
                      {contattiAzienda.telefono1}
                    </a>
                    <a href="tel:+390692963501" className="block text-primary hover:text-secondary font-semibold">
                      {contattiAzienda.telefono2}
                    </a>
                  </div>
                </div>

                <div className="flex items-start bg-gradient-to-r from-primary/5 to-secondary/5 p-4 rounded-xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-primary to-secondary rounded-xl mr-4 flex-shrink-0">
                    <FontAwesomeIcon icon={faEnvelope} className="text-lg text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2 text-gray-800">Email</h3>
                    <a href="mailto:info@servizioclientienergia.com" className="text-primary hover:text-secondary font-semibold break-all">
                      {contattiAzienda.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-start bg-gradient-to-r from-primary/5 to-secondary/5 p-4 rounded-xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-primary to-secondary rounded-xl mr-4 flex-shrink-0">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="text-lg text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2 text-gray-800">Sede Operativa</h3>
                    <p className="text-gray-600">
                      {contattiAzienda.indirizzo}
                    </p>
                  </div>
                </div>

                <div className="flex items-start bg-gradient-to-r from-primary/5 to-secondary/5 p-4 rounded-xl">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-primary to-secondary rounded-xl mr-4 flex-shrink-0">
                    <FontAwesomeIcon icon={faClock} className="text-lg text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2 text-gray-800">Orari di Apertura</h3>
                    <div className="space-y-1 text-sm">
                      <p className="text-gray-600">
                        <span className="font-semibold text-gray-800">Lun-Ven:</span> {contattiAzienda.orarioLavorativo}
                      </p>
                      <p className="text-gray-600">
                        <span className="font-semibold text-gray-800">Sabato:</span> {contattiAzienda.orarioSabato}
                      </p>
                      <p className="text-gray-600">
                        <span className="font-semibold text-gray-800">Domenica:</span> {contattiAzienda.orarioDomenica}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contattaci; 